<template>
  <section class="product-section p-3">
    <h2 class="product-section-title">Product Show</h2>
    <b-container fluid>
      <b-row class="mb-4">
        <b-col class="px-0 show-kv-wrap">
          <transition name="slide-fade" mode="out-in">
            <b-img :key="showKv" :src="showKv" fluid class="show-kv"></b-img>
          </transition>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          v-for="(image, index) in images"
          :key="index"
          class="px-1 show-item-wrap"
        >
          <b-img
            :key="image"
            :src="image"
            fluid
            class="show-item"
            @click="chgImg(image)"
          />
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  props: ["images"],
  data() {
    return {
      showKv: "",
    };
  },
  watch: {
    $route: {
      handler() {
        this.setBigImg();
      },
      immediate: true,
    },
  },
  methods: {
    setBigImg() {
      this.showKv = this.images[0];
    },
    chgImg(image) {
      this.showKv = image;
    },
  },
};
</script>

<style lang="scss">
.show {
  &-kv-wrap {
    border: 1px solid $color-main;
    border-radius: 10px;
    overflow: hidden;
  }
  &-item-wrap {
    max-width: 20%;
  }
  &-item {
    border: 1px solid $color-main;
    cursor: pointer;
  }
}
.slide-fade-enter-active {
  transition: all 0.2s ease;
}
.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
}
</style>